import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, Phone, X, Truck } from "lucide-react";
import { api } from "@/lib/api";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/pricing", label: "Pricing" },
  { to: "/locations", label: "Locations" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/faq", label: "FAQ" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const [phone, setPhone] = useState("(813) 555-0100");
  const location = useLocation();

  useEffect(() => {
    api.get("/config").then(({ data }) => setPhone(data.business_phone)).catch(() => {});
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/95 backdrop-blur" data-testid="site-header">
      <div className="container-wide flex h-16 items-center justify-between gap-4">
        <Link to="/" className="flex flex-shrink-0 items-center gap-2 font-display" data-testid="brand-link">
          <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-sm bg-secondary text-secondary-foreground sm:h-9 sm:w-9">
            <Truck className="h-4 w-4 sm:h-5 sm:w-5" />
          </span>
          <span className="whitespace-nowrap text-base font-black uppercase tracking-tight sm:text-lg">Fast Junk Pros</span>
        </Link>

        <nav className="hidden items-center gap-0.5 lg:flex">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-sm px-2.5 py-2 text-sm font-medium transition-colors ${
                  isActive ? "text-primary" : "text-foreground/80 hover:text-foreground"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href={`tel:${phone.replace(/[^0-9+]/g, "")}`}
            className="hidden items-center gap-2 whitespace-nowrap text-sm font-semibold text-secondary hover:text-primary xl:flex"
            data-testid="header-phone-link"
          >
            <Phone className="h-4 w-4" /> {phone}
          </a>
          <Link to="/contact" className="btn-cta whitespace-nowrap" data-testid="header-quote-cta">
            Get a Free Quote
          </Link>
        </div>

        <button
          className="inline-flex h-10 w-10 items-center justify-center rounded-sm border border-border lg:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-border bg-background lg:hidden" data-testid="mobile-menu">
          <div className="container-wide flex flex-col gap-1 py-4">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                className={({ isActive }) =>
                  `rounded-sm px-3 py-2.5 text-sm font-medium ${isActive ? "bg-muted text-primary" : "text-foreground/80"}`
                }
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {n.label}
              </NavLink>
            ))}
            <a href={`tel:${phone.replace(/[^0-9+]/g, "")}`} className="mt-2 flex items-center gap-2 px-3 py-2.5 text-sm font-semibold text-secondary">
              <Phone className="h-4 w-4" /> {phone}
            </a>
            <Link to="/contact" className="btn-cta mt-2" data-testid="mobile-quote-cta">
              Get a Free Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
